import { computed, Directive, input } from '@angular/core';
import { injectContentDimensions } from '@spartan-ng/brain/core';
import { injectBrnAccordionItem } from './brn-accordion-token';

@Directive({
	selector: 'brn-accordion-content,[brnAccordionContent]',
	host: {
		'[attr.data-state]': 'state?.()',
		'[attr.aria-labelledby]': 'ariaLabeledBy',
		role: 'region',
		'[id]': 'id',
		'[style.--brn-accordion-content-width.px]': '_dimensions.width()',
		'[style.--brn-accordion-content-height.px]': '_dimensions.height()',
		'[attr.inert]': '_inert()',
		'[style]': 'style()',
	},
})
export class BrnAccordionContent {
	private readonly _item = injectBrnAccordionItem();

	protected readonly _dimensions = injectContentDimensions();
	protected readonly _inert = computed(() => (this.state?.() === 'closed' ? true : undefined));

	public readonly state = this._item?.state;
	public readonly id = `brn-accordion-content-${this._item?.id}`;
	public readonly ariaLabeledBy = `brn-accordion-trigger-${this._item?.id}`;
	/**
	 * The style to be applied to the host element after the dimensions are calculated.
	 * @default 'overflow: hidden'
	 */
	public readonly style = input<string>('overflow: hidden');

	constructor() {
		if (!this._item) {
			throw Error('Accordion Content can only be used inside an AccordionItem. Add brnAccordionItem to parent.');
		}
	}
}
